module.exports = __webpack_public_path__ + "static/media/c3.943ce106.jpg";